import React from 'react';

/**
 * Shared module chrome: app-module-shell + optional brand header + optional subnav slot.
 */
export default function ModuleShell({
  title,
  subtitle,
  icon: Icon,
  headerActions,
  subnav,
  children,
  hideHeader = false,
  className = '',
}) {
  return (
    <div className={`app-module-shell ${className}`.trim()}>
      {!hideHeader && (title || headerActions) ? (
        <div className="tk-module-header">
          <div className="tk-module-brand">
            {Icon ? (
              <div className="tk-module-mark" aria-hidden="true">
                <Icon size={20} weight="fill" />
              </div>
            ) : null}
            <div>
              {title ? <h1 className="tk-module-title">{title}</h1> : null}
              {subtitle ? <p className="tk-module-subtitle">{subtitle}</p> : null}
            </div>
          </div>
          {headerActions || null}
        </div>
      ) : null}
      {subnav || null}
      <div className="tk-page page-enter">{children}</div>
    </div>
  );
}
